// Addons data constants
export const ADD_ON = {
  entitlements: {
    'Custom Video': {
      label: 'Custom Video',
    },
  },
}

// Signature codes require onboarding only when includeOnboarding === 'yes' on the plan —
// handled separately in routeAfterOrderDetails, not listed here.
export const SIGNATURE_CODES = [
  'mc_prov2-5-thryv-m2m', // Signature Monthly
  'signature-5-thryv-annual', // Signature Annual
]

export const SIGNATURE_PLUS_CODES = [
  'signature_plus-5-thryv-m2m', // Signature Plus Monthly
  'signature_plus-5-thryv-annual', // Signature Plus Annual
]

export const SEO_CODES = [
  'seobase-5-thryv-m2m',
  'seo-5-thryv-m2m',
  'seombg-5-thryv-m2m',
]

// Keap plans are not listed in appointmentRequiredCodes: only Influencer links
// need an onboarding call for them (Keap Partners onboard their own
// customers), so routeAfterOrderDetails decides per link type.
export const isKeapPlanCode = code => String(code || '').startsWith('keap_')

// Marketing Center plans that need an onboarding call on Influencer links only
// (every MC plan except Starter; Signature is conditional, see SIGNATURE_CODES).
// Keep in sync with ooe-app keapPartnerSchedulingRules.js (1:1).
export const INFLUENCER_MARKETING_CENTER_CODES = [
  'mc_foundation-5-thryv-m2m',
  'mc_freetrial-5-thryv-m2m',
  'mc_plus-5-thryv-m2m',
  'mc_premier-5-thryv-m2m',
  'mc_pro-5-thryv-m2m',
  'premier-5-thryv-annual',
]

// Check if cart contains products that require appointments.
// Marketing Center / TGP plans are deliberately NOT listed here: for Partner
// links Marketing Center alone never schedules a call, matching the 1:1 partner
// rule (ooe-app keapPartnerSchedulingRules.js). Influencer links add
// INFLUENCER_MARKETING_CENTER_CODES in routeAfterOrderDetails. Signature is
// conditional (see SIGNATURE_CODES) and Signature Plus is listed below.
export const appointmentRequiredCodes = [
  'addon-6-mc-socialcontentgen-m2m', // Thryv Social Post
  'wc_plus-5-thryv-m2m', // Workforce Center
  'tl-tax-5-thryv-m2m', // Thryv Leads
  'addon-socialadsbronze-5-m2m', // Social ads
  'addon-socialadssilver-5-m2m', // Social ads
  'addon-socialadsgold-5-m2m', // Social ads
  ...SIGNATURE_PLUS_CODES, // Signature Plus always requires appointment
  ...SEO_CODES, // SEO always requires appointment
]
